import { ProductCategoryEnum } from "src/app/core/enums/product-category.enum";

export type TipoRappel = 'NEUMATICOS' | 'LUBRICANTES_RECAMBIOS';
export type Segmento = 'PCR' | 'TBR' | 'AGR' | 'MOTO' | 'RECAMBIO_LUB';
export type Periodicidad = 'MENSUAL' | 'BIMENSUAL' | 'TRIMESTRAL' | 'SEMESTRAL';

export const ALL_ITEMS_VALUE = 'TODOS';

export enum EstadoRegla {
    ACTIVA = 'ACTIVA',
    INACTIVA = 'INACTIVA',
    PAUSADA = 'PAUSADA'
}
export type TipoIncentivo = 'PORCENTAJE_FACTURACION' | 'EUROS_CANTIDAD' | undefined;

export enum TipoTaller {
    TODOS = 0,
    POINT_S = 1,
    POINT_S_EXPRESS = 2
}

export interface ReglaRappel {
    id?: string;
    nombre: string;
    productCategoryId: ProductCategoryEnum;
    categoriaProductoName?: string;
    subcategoriaProductoIds: string[];

    proveedorIds: string[];
    proveedorNames?: string[];
    marcaIds: string[];
    marcaNames?: string[];
    subcategoriaNames?: string[];
    proveedorId?: string;
    marcaId?: string;

    tallerId?: number;
    tipoTaller: TipoTaller;

    tipoIncentivo: TipoIncentivo;
    valorIncentivo: number;
    periodicidad: Periodicidad;

    estado: EstadoRegla;
    descripcionGenerada?: string;
    observaciones?: string;
    creadoEn?: Date;
    actualizadoEn?: Date;

    acceptedMeasures?: number[];

    tipoRappel?: TipoRappel;
    allCategoriasSelected?: boolean;
    isNew?: boolean;
}

export interface ProductBrand {
    id: string;
    name: string;
    code?: string;
    subcategory?: string;
}

export interface Supplier {
    id: string;
    name: string;
    code?: string;
    email?: string;
    fiscalAddress?: string;
    lastStockImportDate?: Date;
}

export interface ConfiguracionTipoRappel {
    tipoRappel: TipoRappel;
    segmentosDisponibles: Segmento[];
    categoriasDisponibles: string[];
    etiquetaIncentivo: string;
}

export interface FiltrosReglaRappel {
    tipoRappel?: TipoRappel;
    periodicidad?: Periodicidad;
    estado?: EstadoRegla | null;
    proveedorId?: string | null;
    subcategoriaId?: string | null;
    categoriaId?: ProductCategoryEnum | null;
    q?: string;
}



